export function dataURLtoFile(dataUrl, filename) {
  if (!dataUrl) return null;

  const arr = dataUrl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1]; // например, image/png
  const bstr = atob(arr[1]); // декодируем base64
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}